import React from "react";

const VerticalSpace = ({ space = "1rem" }) => {
  return <div style={{ height: space }}></div>;
};

export default VerticalSpace;
